import React, { FC } from 'react';
import styles from './home_container.module.scss';

export const HomeContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
